import React, { Component } from 'react';
import { ChromePicker } from 'react-color';
import { findDOMNode } from 'react-dom';
import { NavLink } from 'react-router-dom';
import $ from "jquery";

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Switch from '@material-ui/core/Switch';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';

import {validateForm, blurValidations} from '../Common/formValidator';
import ModalBox from '../Common/Modals/ModalBox';

import { API } from '../../ws/constants';

import './style.css';

class AddEditUser extends Component {
    constructor(props) {
        super(props);

        const Users = this.props.loginData.profile.Users;
        const userId = this.props.props.match.params.id;

        this.state = {
            userId
            ,openModal:false
            ,showPicker:false
            ,returnTitle: "Erro"
            ,returnText: "Ocorreu algum erro"
            ,editable: (this.props.isAdmin || (Users && Users.permission === 1) || userId === this.props.loginData.Id)
            ,somethingWasEdited: false
            ,fetchSecretQuestions:null
            ,fetchLevels:null
            ,userData:null
            ,loading:false
            ,addEditTitle:"Novo Utilizador"
            ,name:""
            ,username:""
            ,homePhone:""
            ,cellPhone:""
            ,email:""
            ,homeAddress:""
            ,password:""
            ,confirmPassword:""
            ,secretQuestion:""
            ,secretAnswer:""
            ,accessLevels:""
            ,notes:""
            ,userColor:""
            ,isActive:"1"
        };
    }
    thisUserLevel = null;

    componentDidMount() {
        const { userId } = this.state;
        const { isAdmin, loginData } = this.props;

        const isThisUser = userId === loginData.Id;

        if(isAdmin || loginData.profile.Users || isThisUser){
            const fetches = [
                fetch(API + "getsecretquestions")
                , fetch(API + "getaccesslevels")
            ];

            Promise.all(fetches)
            .then(responses => Promise.all(responses.map(r => r.json())))
            .then(result => this.setState({ fetchSecretQuestions: result[0].data, fetchLevels: result[1].data }));

            if(userId > 0){
                fetch(API + 'getusers&getbyid=' + userId)
                .then(response => response.json())
                .then(result => {
                    const userData = result.data;

                    if(result === null || result.shortmsg === "NOK"){
                        this.props.props.history.push('/Users');
                        return;
                    }

                    this.thisUserLevel = userData.AccessLevel;
                    this.setState({ 
                        userData
                        , addEditTitle: userData.Name
                        , name: userData.Name
                        , username: userData.Username
                        , homePhone: userData.HomePhone
                        , cellPhone: userData.CellPhone
                        , email: userData.Email
                        , homeAddress: userData.HomeAddress
                        , password: userData.Password
                        , confirmPassword: userData.Password
                        , secretQuestion: userData.SecretQuestionId
                        , secretAnswer: userData.SecretAnswer
                        , accessLevels: userData.AccessLevel
                        , notes: userData.Notes
                        , userColor: userData.UserColor
                        , isActive: userData.IsActive
                    });
                });
            }
        }else{
            this.props.props.history.push('/Users');
        }
        blurValidations($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false });
    }

    handleFieldChange = (e) => this.setState({ [e.target.id]: e.target.value, somethingWasEdited:true });
    handleSelectChange = (e) => this.setState({ [e.target.name]: e.target.value, somethingWasEdited:true });
    handleTitleChange = (e) => this.setState({ [e.target.id]: e.target.value, addEditTitle: e.target.value, somethingWasEdited:true });
    handleToggle = (e, value) => this.setState({ [e.target.id]: value ? "1" : "0", somethingWasEdited:true });
    handleColorChange = (value) => {this.setState({userColor: value.hex, somethingWasEdited:true});}

    handleSave = (e) => {
        if(!this.state.somethingWasEdited)
            return;
            
        if(validateForm($(findDOMNode(this.refs.editForm)), { validateHiddenFields: true, showErrorMessage: true, dumbValidations: false })){
            let DEFAULT_QUERY = "saveuser&userid=" + this.state.userId + "&name=" + this.state.name.trim() + "&username=" + this.state.username.trim() + "&homephone=" + this.state.homePhone.trim()
                                + "&cellphone=" + this.state.cellPhone.trim() + "&email=" + this.state.email.trim() + "&homeaddress=" + this.state.homeAddress.trim() + "&password=" + this.state.password
                                + "&secretquestion=" + this.state.secretQuestion + "&secretanswer=" + this.state.secretAnswer + "&accesslevels=" + this.state.accessLevels + "&notes=" + this.state.notes.trim()
                                + "&isactive=" + this.state.isActive + "&usercolor=" + this.state.userColor.replace("#","") + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name;

            this.setState({loading:true});
            fetch(API + DEFAULT_QUERY)
            .then(response => response.json())
            .then(result => {
                const userId = this.state.userId > 0 ? this.state.userId : parseInt(result.data, 10);
                const saveSuccess = result.shortmsg === "OK";

                this.setState({ 
                    returnTitle: saveSuccess ? "Sucesso" : "Erro"
                    , returnText: result.message
                    , userId
                });

                if(saveSuccess && this.thisUserLevel !== this.state.AccessLevel){
                    this.saveProfile(userId);
                }
            });
        }
    }

    saveProfile(userId) {  
        const defaults = this.props.config.profileDefaults["level"+this.state.accessLevels];        
        
        fetch(API + 'getprofile&userid='+userId)
        .then(response => response.json())
        .then(result => {
            // if(userId > 0 && !result.data.length){ // Se descomentado, só altera o profile a primeira vez que o user é criado. (ao invés de sempre que é alterado o nível)
                let SAVE_QUERY = "saveprofile&userid=" + this.state.userId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name;
        
                for (let field in defaults) {
                    if (defaults.hasOwnProperty(field)) {
                        SAVE_QUERY += "&"+field+"="+defaults[field];
                    }
                }
                
                fetch(API + SAVE_QUERY)
                .then(response => response.json())
                .then(result => this.setState({ openModal: true, loading: false }));
            // }else{
            //     this.setState({ openModal: true, loading: false });
            // }
        });
    }

    modalCallBack = (result, keepModalOpen) => {
        this.setState({ openModal: keepModalOpen });
        this.props.props.history.push('/Users');
    }

    handleDelete = (e) => {
        if(window.confirm("Tem a certeza que quer apagar este utilizador?")){
            this.setState({loading:true});
            fetch(API + 'deleteuser&userid=' + this.state.userId + "&cur_userid=" + this.props.loginData.Id + "&cur_username=" + this.props.loginData.Name)
            .then(response => response.json())
            .then(result => {
                this.setState({ returnTitle: result.shortmsg === "OK" ? "Sucesso" : "Erro", returnText: result.message , openModal: true, loading:false });
            });
        }
    }

    showPicker = () => {
        this.setState({showPicker:true});
    }

    hidePicker = () => {
        this.setState({showPicker:false});
    }

    renderSecretQuestionOptions = (e) => {
        const secretQuestions = this.state.fetchSecretQuestions;
        if(secretQuestions===null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=secretQuestions.length;i<n;i++) {
            items.push(<MenuItem value={secretQuestions[i].Id} key={secretQuestions[i].Id}>{secretQuestions[i].Question}</MenuItem>);
        }
        return items;
    }

    renderAccessLevelsOptions = (e) => {
        const levels = this.state.fetchLevels;
        if(levels===null || this.props.loginData==null)
            return;

        const items = [<MenuItem value="0" key="0" disabled={true}>Escolha uma opção</MenuItem>];
        for (let i=0,n=levels.length;i<n;i++) {
            let push = this.props.loginData.AccessLevel > levels[i].AccessLevel;

            items.push(!push && <MenuItem value={levels[i].AccessLevel} disabled={push} key={levels[i].Id}>{levels[i].AccessName + " (nível: " + levels[i].AccessLevel + ")"}</MenuItem>);
        }
        return items;
    }

    render() {
        const { isAdmin, loginData, config } = this.props;
        const { userId, editable } = this.state;

        const optsQuestions = this.renderSecretQuestionOptions()
             , optsLevels = this.renderAccessLevelsOptions()
             , isThisUser = userId === loginData.Id
             , loadingClass = this.state.loading ? " ajaxLoading" : "";

        return (
            <div id="addEditUserPage" ref="editForm" className={"form addEditPage" + loadingClass}>
                <div className="row">
                    <div className="col-12">
                        <h1>
                            <i className="fa fa-users"></i> {this.state.addEditTitle}
                            { (isAdmin || (loginData.profile.Users && loginData.profile.Users.isActive)) && 
                                <span className="float-right">
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                id="isActive"
                                                checked={!!+this.state.isActive}
                                                disabled={!(isAdmin || (loginData.profile.Users.isActive.permission === 1 && editable))}
                                                onChange={this.handleToggle}
                                                color="primary"/>
                                        }
                                        label="Ativo"/>
                                </span>
                            }
                            <span className="fieldHolder colorPickerHolder float-right">
                                <label htmlFor="colorPicker">Escolher Côr</label>
                                <div className="colorPickerTrigger" onClick={this.state.showPicker ? this.hidePicker : this.showPicker} style={{backgroundColor:this.state.userColor}}></div>
                                { this.state.showPicker &&
                                    <div>
                                        <ChromePicker
                                            id="colorPicker"
                                            color={this.state.userColor}
                                            defaultValue="#FF0000"
                                            onChangeComplete={this.handleColorChange}
                                        />
                                        <div className="cover" onClick={ this.hidePicker }/>
                                    </div>
                                }
                            </span>
                        </h1>
                    </div>
                </div>
                { config.features.profile && userId > 0 && (isAdmin || loginData.profile.Users) && 
                    <div className="row">
                        <div className="col-12">
                            <span className="float-right"><i className="far fa-id-badge"></i> <NavLink to={"/Users/UserProfile/"+userId+"/"+this.state.name}>Ver Perfil</NavLink></span>
                        </div>
                    </div>
                }
                <div className="row">
                    <div className="col-12 col-md-6">
                        <div className="fieldHolder required">
                            <TextField fullWidth
                                       id="name"
                                       value={this.state.name}
                                       onChange={this.handleTitleChange}
                                       label="Nome"
                                       placeholder="Introduza o nome"
                                       disabled={!editable}
                                       data-empty-error-message="Este campo não pode estar vazio" />
                        </div>
                        <div className="fieldHolder required">
                            <TextField fullWidth
                                       id="username"
                                       value={this.state.username}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       label="Nome de Utilizador"
                                       placeholder="Introduza o seu nome de Utilizador"
                                       data-empty-error-message="Este campo não pode estar vazio" />
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="homePhone"
                                       value={this.state.homePhone}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       label="Número de telefone de casa"
                                       placeholder="Introduza o número de telefone de casa" />
                        </div>
                        <div className="fieldHolder required">
                            <TextField fullWidth
                                       id="cellPhone"
                                       value={this.state.cellPhone}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       label="Número de telemóvel"
                                       placeholder="Introduza o número de telemóvel"
                                       data-empty-error-message="Este campo não pode estar vazio" />
                        </div>
                        <div className="fieldHolder required validEmail">
                            <TextField fullWidth
                                       id="email"
                                       value={this.state.email}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       label="Email"
                                       placeholder="Introduza o email"
                                       data-email-error-message="Este email não está correto."
                                       data-empty-error-message="Este campo não pode estar vazio" />
                        </div>
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="homeAddress"
                                       value={this.state.homeAddress}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       multiline
                                       rows={4}
                                       label="Morada"
                                       placeholder="Introduza a morada" />
                        </div>
                    </div>
                    <div className="col-12 col-md-6">
                        { (isAdmin || isThisUser || (loginData.profile.Users && loginData.profile.Users.passwordInput)) &&
                            <div>
                                <div className="fieldHolder required compare" data-compare-obj="confirmPassword" data-compare-error-message="Os valores têm que ser iguais.">
                                    <TextField fullWidth
                                            id="password"
                                            value={this.state.password}
                                            onChange={this.handleFieldChange}
                                            disabled={!editable}
                                            label="Password"
                                            placeholder="Introduza a Password"
                                            data-empty-error-message="Este campo não pode estar vazio"
                                            type="password" />
                                </div>
                                <div className="fieldHolder required compare" data-compare-obj="password" data-compare-error-message="Os valores têm que ser iguais.">
                                    <TextField fullWidth
                                            id="confirmPassword"
                                            value={this.state.confirmPassword}
                                            onChange={this.handleFieldChange}
                                            disabled={!editable}
                                            label="Confirm Password"
                                            placeholder="Introduza a mesma Password"
                                            data-empty-error-message="Este campo não pode estar vazio"
                                            type="password" />
                                </div>
                            </div>
                        }
                        { (isAdmin || isThisUser || (loginData.profile.Users && loginData.profile.Users.secretQuestion)) &&
                            <div>
                                <div className="fieldHolder required selectField">
                                    <FormControl fullWidth>
                                        <InputLabel htmlFor="secretQuestion">Pergunta secreta</InputLabel>
                                        <Select id="secretQuestion"
                                                name="secretQuestion"
                                                value={this.state.secretQuestion}
                                                onChange={this.handleSelectChange}
                                                disabled={!editable}
                                                data-empty-error-message="Este campo não pode estar vazio">
                                        {optsQuestions}
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="fieldHolder required">
                                    <TextField fullWidth
                                            id="secretAnswer"
                                            value={this.state.secretAnswer}
                                            onChange={this.handleFieldChange}
                                            disabled={!editable}
                                            className="required"
                                            label="Resposta secreta"
                                            placeholder="Introduza a resposta secreta"
                                            data-empty-error-message="Este campo não pode estar vazio"
                                            type="password" />
                                </div>
                            </div>
                        }
                        { (isAdmin || (loginData.profile.Users && loginData.profile.Users.accessLevels)) &&
                        <div className="fieldHolder selectField">
                            <FormControl fullWidth>
                                <InputLabel htmlFor="accessLevels">Nível de acesso</InputLabel>
                                <Select id="accessLevels"
                                        name="accessLevels"
                                        value={this.state.accessLevels}
                                        onChange={this.handleSelectChange}
                                        disabled={!editable}
                                        data-empty-error-message="Este campo não pode estar vazio">
                                  {optsLevels}
                                </Select>
                            </FormControl>
                        </div>
                        }
                        <div className="fieldHolder">
                            <TextField fullWidth
                                       id="notes"
                                       value={this.state.notes}
                                       onChange={this.handleFieldChange}
                                       disabled={!editable}
                                       multiline
                                       rows={4}
                                       label="Observações" />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 buttonsHolder">
                        <Button onClick={this.props.props.history.goBack} variant="contained" className="defaultButton">Voltar</Button>
                        {this.props.loginData.AccessLevel < 1 && this.state.userId !== "New" && <Button onClick={this.handleDelete} className="button button-danger">Apagar Utilizador</Button>}
                        {editable && <Button onClick={this.handleSave} className="button float-right" variant="contained" color="primary"><i className='fa fa-check'></i> Salvar</Button>}
                    </div>
                </div>
                {this.state.openModal && <ModalBox modalCallBack={this.modalCallBack} isActive={this.state.openModal} modalHtml={<div className="col-12"><h2>{this.state.returnTitle}</h2><p>{this.state.returnText}</p></div>} />}
            </div>
        );
    }
}

export default AddEditUser;
